import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "filter-slider" }
const _hoisted_2 = { class: "filter-slider__number" }
const _hoisted_3 = { class: "filter-slider__slider" }
const _hoisted_4 = { class: "filter-slider__number filter-slider__number--max" }

import { computed, ref } from 'vue'
import { NSlider } from 'naive-ui'
import { useDebounceFn } from '@vueuse/core'
import { CommonSliderFilterType } from '@/types/filter'


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonSliderFilter',
  props: {
    unit: {},
    summaryPrefix: {},
    filter: {}
  },
  emits: ["updated", "summary"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const minNumber = ref(Object.values(props.filter['min'])[0] as number)
const maxNumber = ref(Object.values(props.filter['max'])[0] as number)

const numberRange = ref([minNumber.value, maxNumber.value])

const updateMinMax = () => {
  changeWidthFilter(Object.keys(props.filter['value'])[0], false)
  changeWidthFilter(Object.keys(props.filter['min'])[0], minNumber.value)
  changeWidthFilter(Object.keys(props.filter['max'])[0], maxNumber.value)

  emits('summary', summary.value)
  debouncedEmit(filtersToEmit.value)
}

const summary = computed(
  () =>
    `${props.summaryPrefix}: ${minNumber.value} - ${maxNumber.value} ${props.unit}`,
)

const filtersToEmit = ref<Record<string, string | number | boolean>>({})
const changeWidthFilter = (key: string, e: number | boolean) => {
  filtersToEmit.value[key] = e
}

const emits = __emit

const debouncedEmit = useDebounceFn((val) => emits('updated', val), 500)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(`${minNumber.value} ${__props.unit}`), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(NSlider), {
        value: numberRange.value,
        "onUpdate:value": [
          _cache[0] || (_cache[0] = ($event: any) => ((numberRange).value = $event)),
          _cache[1] || (_cache[1] = 
          (val) => {
            minNumber.value = val[0]
            maxNumber.value = val[1]
            updateMinMax()
          }
        )
        ],
        range: "",
        step: 1,
        min: Object.values(__props.filter['min'])[0] as number,
        max: Object.values(__props.filter['max'])[0] as number
      }, null, 8, ["value", "min", "max"])
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(`${maxNumber.value} ${__props.unit}`), 1)
  ]))
}
}

})